import axios from "axios";
import { api_url } from '../config/config';
import { useState, useEffect, useContext, createContext } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [contextCategories,  setContextCategories]  = useState([]);
  const [contextBrands,      setContextBrands]      = useState([]);
  const [contextConcerns,    setContextConcerns]    = useState([]);
  const [contextHeroImages,  setContextHeroImages]  = useState([]);

  useEffect(() => {
    const fetchAllData = async () => {
     
      const safeFetch = async (url) => {
        try {
          const res = await axios.get(url); // ← no headers at all
          return res.data;
        } catch (err) {
          console.error(`Error fetching ${url}:`, err.message);
          return null;
        }
      };

      const [catData, brandData, concernData, heroData] = await Promise.all([
        safeFetch(`${api_url}/categories?page=1&limit=100`),
        safeFetch(`${api_url}/manufacturer?page=1&limit=100`),
        safeFetch(`${api_url}/concerns?page=1&limit=100`),
        safeFetch(`${api_url}/hero`),
      ]);

      setContextCategories(catData?.results   || []);
      setContextBrands(brandData?.results     || []);
      setContextConcerns(concernData?.results || []);
      setContextHeroImages(heroData?.data     || []);
    };

    fetchAllData();
  }, []);

  return (
    <AppContext.Provider
      value={{ contextBrands, contextCategories, contextConcerns, contextHeroImages }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);